<template>
	<div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <h2 v-if="showCreditabs" class="card-title">Mis créditos activos</h2>
        <h2 v-else>Entrevista con Avatar</h2>
      </div>
      <div class="card-body">
    		<div class="row">
          <div class="col-sm-12">
            <p>Debido a que has solicitado una reestructura queremos conocerte un poco mejor, por lo cuál serás redireccionado a una entrevista con nuestro avatar. Deberás tener en consideración lo siguiente:</p>
              <ol>
               <li>Tener un equipo de computo con cámara y micrófono o en su lugar un celular con cámara y micrófono (manos libres)</li>
               <li>Tener buena conexión a internet (WiFi de preferencia)</li>
               <li>Usar navegador Google Chrome (última versión)</li>
               <li>No permitir que el navegador haga traducción de la página</li>
               <li>Permitir el uso de cámara y micrófono antes de iniciar la entrevista</li>
               <li>Realizar la entrevista en un lugar en silencio y bien iluminado para evitar problemas al evaluar</li>
              </ol>
          </div>
          <div class="col-sm-4">
            <div class="avatar-video">
              <video autoplay controls>
                <source src="https://static.bienparabien.com/videos/Reestructura_Avatar.mp4" type="video/mp4" />Your browser does not support HTML5 video.
              </video>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-2 offset-sm-5"><button class="btn btn-bpb-primary" @click="iniciar_avatar">Realizar entrevista</button></div>
        </div>
      </div>
    </div>
	</div>
</template>

<script type="text/javascript">
  export default {
    methods: {
      hasUserMedia: function() {
        return !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
      }
      ,iniciar_avatar: function() {
        this.$router.push({name: 'avatar'})
      }
    },
    computed: {
      credenciales: function() {
        return {
          membershipKey: process.env.VUE_APP_NAUPHILUS_MEMBERSHIP_KEY,
          apiClientID: process.env.VUE_APP_NAUPHILUS_API_CLIENT_ID,
          apiClientSecretKey: process.env.VUE_APP_NAUPHILUS_API_CLIENT_SECRET_KEY
        }
      }
    }
  }
</script>